/**
 * Context exposing the countries/languages the shop is published in, as
 * returned by /locale/options. Fetched once by AppContent; consumed by the
 * footer's location selector, which needs the localized country names.
 * Null while loading, or when a subtree renders outside the provider.
 *
 * Exists so pages that bypass Layout (checkout has its own chrome) can still
 * show the visitor's country instead of falling back to "Global".
 */

import { createContext, useContext } from "react";
import type { LocaleOptions } from "@/api/locale";

export const LocaleOptionsContext = createContext<LocaleOptions | null>(null);

/** Named ...Context to keep it distinct from the useLocaleOptions FETCH hook. */
export function useLocaleOptionsContext(): LocaleOptions | null {
  return useContext(LocaleOptionsContext);
}
